<template>
    <div class="inner-wrapper">
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" @submit.prevent="search(1)">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterForm.search_filter" type="text" class="form-control"
                                               placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                        <a href="javascript:void(0)" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin')" data-toggle="modal" data-target="#addTaskWorkflowModal" class="btn create-btn">
                                            <i  class="ri-add-circle-line align-bottom me-1"></i> Add Task Workflow
                                        </a>
                                        <div class="quotes-text">{{ total }} Task Workflows</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>


            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="card panel ">
                        <div class="card-body p-0" v-if="workflowData.workflows">
                            <div class="table-responsive product-create mb-0">
                                <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Event</th>
                                        <th v-if="isRule">Rule</th>
                                        <th>Type</th>
                                        <th>Module</th>
                                        <th style="width: 80px">Action </th>
                                    </tr>
                                    </thead>
                                    <tr v-for="(workflow, index) in workflowData.workflows.data" :key="workflow.id" :id="workflow.id">
                                        <td class="t-sts"> {{ workflow.name }}  </td>
                                        <td> {{workflow.task_event.name}} </td>
                                        <td v-if="isRule"> {{workflow.rule ? workflow.rule.rule : ''}} </td>
                                        <td>{{workflow.is_create == 1 ? 'Create Task' : 'Close Task' }}</td>
                                        <td>{{workflow.module == 1 ? 'SO' : 'PO' }}</td>
                                        <td>
                                            <a href="javascript:void(0)" @click="editTaskWorkflow(workflow)" class="edit_btn" title="Edit TaskWorkflow"><i class="ri-edit-fill me-1"></i></a>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>

                        <div class="btnrow text-left mb-3">
                            <template v-if="workflowData.workflows != null && workflowData.workflows.data.length">
                                <div class="overflow-auto">
                                    <b-pagination
                                        v-model="current_page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <AddTaskWorkflow :workflow="workflow"
                         :events="workflowData.events"
                         :soStatuses="workflowData.so_statuses"
                         :poStatuses="workflowData.po_statuses"
                         :priorities="workflowData.priorities"
                         :rules="workflowData.rules"
                         @addedEvent="workflowAddedEvent" @updatedEvent="workflowUpdatedEvent"></AddTaskWorkflow>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AddTaskWorkflow from "../../components/AddTaskWorkflow";
import moment from "moment";
import axios from "axios";

export default {
    name: "TaskWorkflowWorkflows",
    components: {AddTaskWorkflow},
    created() {

    },
    mounted() {
        this.getTaskWorkflows();
        let self = this;
        $('#addTaskWorkflowModal').on('hidden.bs.modal', function () {
            self.workflow = null;
        });
    },
    data(){
        return {
            enableAction: false,
            workflow: null,
            current_page:1,
            per_page:5,
            total:0,
            filterForm: {
                search_filter: null
            },
            workflowData: {
                workflows: null,
                events: [],
                so_statuses: [],
                po_statuses: [],
                priorities: [],
                rules: []
            },
            isRule: true
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        search(buttonIndex) {
            if(buttonIndex === 1) {
                this.getTaskWorkflows();
            } else {
                this.getTaskWorkflows();
            }
        },
        editTaskWorkflow(workflow) {
            this.workflow = _.cloneDeep(workflow);
            setTimeout(() => {
                $('#addTaskWorkflowModal').modal('show');
            }, 100);
        },
        workflowAddedEvent(event){
            this.getTaskWorkflows();
            $('#addTaskWorkflowModal').modal('hide');
        },
        workflowUpdatedEvent(event){
            this.workflow = null;
            this.getTaskWorkflows();
            $('#addTaskWorkflowModal').modal('hide');
        },
        getTaskWorkflows() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('task-workflows.index', {
                search_filter: this.filterForm.search_filter,
                page: this.current_page,
            }), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors && data.errors.length){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.workflowData.workflows = data.data.workflows;
                        this.workflowData.events = data.data.events;
                        this.workflowData.so_statuses = data.data.so_statuses;
                        this.workflowData.po_statuses = data.data.po_statuses;
                        this.workflowData.priorities = data.data.priorities;
                        this.workflowData.rules = data.data.rules;
                        this.per_page = data.data.workflows.per_page;
                        this.total = data.data.workflows.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteTaskWorkflow() {
            if(this.deleteId) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('task-workflows.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.getTaskWorkflows();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    watch: {
        current_page: {
            handler: function (value) {
                this.getTaskWorkflows();
            }
        },
    }
}
</script>

<style scoped>

</style>
